// services/api.js
import axios from 'axios';

// Создаем экземпляр axios с базовым URL
const api = axios.create({
    baseURL: '', // Убираем '/api', так как уже включен в REACT_APP_API_URL
    withCredentials: true  // Важно! Это заставит axios отправлять cookie с каждым запросом
});

// Добавляем перехватчик для обработки ошибок
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log('API Error:', error.response?.status, error.response?.data); // Для отладки

        // Обрабатываем ошибку 401 (Unauthorized) - перенаправляем на страницу логина
        // Но только если мы еще не на странице логина или регистрации
        if (error.response && error.response.status === 401) {
            const currentPath = window.location.pathname;
            // Предотвращаем циклические редиректы
            if (currentPath !== '/login' && currentPath !== '/register') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;